/* KEEP THE EXPORTS IN ALPHABETICAL ORDER */

import ARROW_LEFT from '../assets/arrow-left.svg';
import ARROW_RIGHT from '../assets/arrow-right.svg';
import ARROW_UP_RIGHT from '../../../plugins/controlsPlugin/assets/arrow-up-right.svg';
import CHECK_FILL from '../assets/check-fill.svg';
import CLOSE_BLUR from '../assets/close-blur.svg';
import FULLSCREEN_ENTER from '../assets/fullscreen-enter.svg';
import FULLSCREEN_EXIT from '../assets/fullscreen-exit.svg';
import PAUSE_FILL from '../assets/pause-fill.svg';
import PLAY_FILL from '../assets/play-fill.svg';
import REPLAY_BLUR from '../assets/replay-blur.svg';
import REPLAY_FILL from '../assets/replay-fill.svg';
import SETTINGS from '../assets/settings.svg';
import SHARE_FILL from '../assets/share-fill.svg';
import SKIP_VIDEO_FILL from '../assets/skip-forward-fill.svg';
import VOLTAX_LOGO from '../assets/voltax-logo.svg';
import VOLUME_MUTE from '../assets/volume-mute.svg';
import VOLUME_UNMUTE from '../assets/volume-unmute.svg';
import PAUSE_BLUR from '../assets/pause-blur.svg';

export const CONTROLS_ICON_TYPES = {
  ARROW_LEFT,
  ARROW_RIGHT,
  ARROW_UP_RIGHT,
  CHECK_FILL,
  CLOSE_BLUR,
  FULLSCREEN_ENTER,
  FULLSCREEN_EXIT,
  PAUSE_BLUR,
  PAUSE_FILL,
  PLAY_FILL,
  REPLAY_BLUR,
  REPLAY_FILL,
  SETTINGS,
  SHARE_FILL,
  SKIP_VIDEO_FILL,
  VOLTAX_LOGO,
  VOLUME_MUTE,
  VOLUME_UNMUTE,
};
